import React, {useCallback} from 'react';
import {postData} from '../../../util/api';
import SendIcon from '@mui/icons-material/Send';
import {Button} from '@mui/material';
import {useDispatch} from 'react-redux';
import {
  setIsSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity
} from '../../../components/Snackbar/slice';

export const ExportButton = ({filename, data}) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(async () => {
    try {
      await postData(filename, data);
      dispatch(setSnackbarSeverity('success'));
      dispatch(setSnackbarMessage('File export successful.'));
      dispatch(setIsSnackbarOpen(true));
    } catch (error) {
      dispatch(setSnackbarSeverity('error'));
      dispatch(setSnackbarMessage('Export failed, please try again.'));
      dispatch(setIsSnackbarOpen(true));
      console.error(error);
    }
  }, [filename, data, dispatch]);

  return (
    <Button
      size='large'
      // disabled={data.broadcaster==='RBB'}
      style={{textTransform: 'none'}}
      variant='contained'
      color={'primary'}
      endIcon={data.broadcaster !== 'RBB' && <SendIcon />}
      onClick={handleClick}>
      {data.broadcaster === 'RBB' ? 'Speichern' : 'Exportieren'}
    </Button>
  );
};
